<template>
  <shared-provide-variation
    :variation="variation"
    :fromModule="fromModule"
    :toModule="toModule"
    @change="emitToParent"
  >
    <div class="l-row">
      <loader :loading="loadingVariationAttributes" />

      <form-group
        v-for="attribute in variationAttributes"
        :key="attribute.id + '-' + (variation.sku || variation.id || '')"
        :label="attribute.name"
        :columns="6"
        :required="attribute.isRequired"
        :error="getError(String(attribute.id), variation.sku)"
      >
        <multiselect
          v-if="attribute.isMultipleSelection || attribute.isCustomizable"
          :key="'ms-' + attribute.id + '-' + (variation.sku || variation.id || '')"
          v-model="localVarAttrs[attribute.id]"
          :options="attribute.values || []"
          track-by="id"
          label="name"
          :multiple="attribute.isMultipleSelection || attribute.isCustomizable"
          :close-on-select="!attribute.isMultipleSelection"
          :clear-on-select="false"
          :hide-selected="true"
          :taggable="attribute.isCustomizable"
          @tag="val => addCustomTag(attribute, val)"
          :placeholder="getVariationAttributePlaceholder(attribute)"
          :disabled="disabledInputs()"
        />

        <select
          v-else-if="attribute.values && attribute.values.length"
          :key="'ss-' + attribute.id + '-' + (variation.sku || variation.id || '')"
          v-model="localVarAttrs[attribute.id]"
          class="form-select"
          :disabled="disabledInputs() || loadingVariationAttributes"
        >
          <option :value="null" disabled>{{ getVariationAttributePlaceholder(attribute) }}</option>
          <option
            v-for="val in attribute.values"
            :key="val.id"
            :value="{ id: val.id, name: val.name }"
          >
            {{ val.name }}
          </option>
        </select>

        <input
          v-else
          type="text"
          class="form-input"
          :key="'tx-' + attribute.id + '-' + (variation.sku || variation.id || '')"
          :value="(localVarAttrs[attribute.id] && localVarAttrs[attribute.id].name) || ''"
          @input="e => $set(localVarAttrs, attribute.id, e.target.value ? { id: null, name: e.target.value } : null)"
          :placeholder="getVariationAttributePlaceholder(attribute)"
          :disabled="disabledInputs() || loadingVariationAttributes"
        />
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
import { mapGetters } from 'vuex'
import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
import FormGroup from '@/components/template/FormGroup'
import Loader from '@/components/template/Loader'
import Multiselect from 'vue-multiselect'

export default {
  name: 'MarketplaceProvideVariationShein',
  props: {
    variation: { type: Object, required: true },
    fromModule: { type: Object, required: true },
    toModule: { type: Object, required: true },
    variationAttributes: { type: Array, default: () => [] },
    loadingVariationAttributes: { type: Boolean, default: false }
  },
  data () {
    return {
      localVarAttrs: Object.create(null) // { [attrId]: Array|Object|null } — por variação
    }
  },
  methods: {
    disabledInputs () { return this.variation.status === 'sent' || this.variation.status === 'error' },
    emitToParent (value) { this.$emit('change', value) },

    ensureVariationAttrShape () {
      if (!this.variation.attributes || Array.isArray(this.variation.attributes) || typeof this.variation.attributes !== 'object') {
        this.$set(this.variation, 'attributes', {})
      }

      this.variationAttributes.forEach(attr => {
        const cur = this.variation.attributes[attr.id]
        if (attr.isMultipleSelection || attr.isCustomizable) {
          if (!Array.isArray(cur)) {
            this.$set(this.variation.attributes, attr.id, [])
          } else if (cur.length && typeof cur[0] !== 'object') {
            const mapped = cur
              .map(id => (attr.values || []).find(v => String(v.id) === String(id)))
              .filter(Boolean)
              .map(o => ({ id: String(o.id), name: String(o.name) }))
            this.$set(this.variation.attributes, attr.id, mapped)
          }
        } else {
          if (cur == null) {
            this.$set(this.variation.attributes, attr.id, null)
            return
          }
          if (Array.isArray(cur)) {
            const first = cur[0]
            this.$set(this.variation.attributes, attr.id, first ? { id: String(first.id), name: String(first.name) } : null)
            return
          }
          if (typeof cur !== 'object') {
            let found = (attr.values || []).find(v => String(v.id) === String(cur) || String(v.name) === String(cur))
            if (!found) {
              if (!attr.values) this.$set(attr, 'values', [])
              attr.values.push({ id: String(cur), name: String(cur), custom: true })
              found = attr.values[attr.values.length - 1]
            }
            this.$set(this.variation.attributes, attr.id, { id: String(found.id), name: String(found.name) })
          }
        }
      })

      this.variationAttributes.forEach(attr => {
        const cur = this.variation.attributes[attr.id]
        if (Array.isArray(cur)) {
          this.$set(this.localVarAttrs, attr.id, cur.map(o => ({ id: String(o.id), name: String(o.name), custom: !!o.custom })))
        } else if (cur && typeof cur === 'object') {
          this.$set(this.localVarAttrs, attr.id, { id: String(cur.id), name: String(cur.name) })
        } else if (cur == null) {
          this.$set(this.localVarAttrs, attr.id, null)
        } else {
          this.$set(this.localVarAttrs, attr.id, { id: null, name: String(cur) })
        }
      })
    },

    addCustomTag (attribute, val) {
      if (!attribute.values) this.$set(attribute, 'values', [])
      const exists = attribute.values.some(v => String(v.id) === String(val))
      if (!exists) attribute.values.push({ id: String(val), name: String(val), custom: true })

      if (attribute.isMultipleSelection || attribute.isCustomizable) {
        const cur = Array.isArray(this.localVarAttrs[attribute.id]) ? [...this.localVarAttrs[attribute.id]] : []
        if (!cur.some(v => String((v && v.id) || v) === String(val))) {
          cur.push({ id: String(val), name: String(val), custom: true })
        }
        this.$set(this.localVarAttrs, attribute.id, cur)
      } else {
        this.$set(this.localVarAttrs, attribute.id, { id: String(val), name: String(val), custom: true })
      }
    }
  },
  computed: {
    ...mapGetters('errors', ['getError']),
    getVariationAttributePlaceholder () {
      return (attribute) => {
        if (attribute.isMultipleSelection) return `Selecione um ou mais valores de ${attribute.name}`
        if (attribute.isCustomizable) return `Selecione ou digite o valor de ${attribute.name}`
        if (attribute.values && attribute.values.length) return `Selecione o valor de ${attribute.name}`
        return `Informe o valor de ${attribute.name}`
      }
    }
  },
  watch: {
    variationAttributes: {
      handler () { this.ensureVariationAttrShape() },
      immediate: true
    },
    localVarAttrs: {
      deep: true,
      handler (val) {
        Object.keys(val).forEach(attrId => {
          const cur = val[attrId]
          if (Array.isArray(cur)) {
            this.$set(this.variation.attributes, attrId, cur.map(o => ({ id: String(o.id), name: String(o.name), custom: !!o.custom })))
          } else if (cur && typeof cur === 'object') {
            this.$set(this.variation.attributes, attrId, { id: String(cur.id), name: String(cur.name) })
          } else if (cur == null) {
            this.$set(this.variation.attributes, attrId, null)
          } else {
            this.$set(this.variation.attributes, attrId, { id: null, name: String(cur) })
          }
        })
      }
    }
  },
  components: { SharedProvideVariation, FormGroup, Loader, Multiselect }
}
</script>

<style lang="sass" scoped>
.form-input,
.form-select:not(.form-select--sm)
  height: 42px
</style>



// WEBPACK FOOTER //
// Variation.vue?15c87012